import request from "@/utils/request";
export const options = {
    //---------内招
    x_haspernr_options: "",//是否有员工号
    //---------基本信息
    gesch_options: "", //性别
    pcode_options: "", //政治面貌
    zzmzu_options: "", //民族
    zzhkl_options: "", //户口性质
    zjkzk_options: "", //健康状况
    znjpm_options:"",
    famst_options: "", //婚姻状况
    //是否有亲属在五粮液
    inwly_options: "",//是否
    zhr_dptyp_options: "", //关系

    x_zfctj_options: "",//是否服从岗位调剂

    x_cjrzqsx_options: "",//是否可以参加入职前实习

    //---------紧急联系人
    zhr_jjybrgx_options: "", //与本人关系

    //---------信息来源
    zxxly_options: "", //信息来源

    //---------意向面试地点
    zmsd_options: "",

    //---------是否复转军人
    retire_soldier_options: "",

    //---------教育经历
    p9100: {
        zhr_xl_options: "", //学历
        zhr_xwdj_options: "", //学位
        zhr_xxxs_options: "" //学习形式
    },
    // 工作经历
    p9101:{
      zhr_gzxz_options:""
    },
    //---------语言能力
    p9103: {
        zhr_wyyz_options: "", //外语语种
        zhr_slcd_options: "", //熟练程度
        // zhr_wyjb_options: "" //外语等级 (联动的),在form对象中实现
    },
    //---------专业技术资格 (联动的)1000
    p9109_zy: {
        zhr_zcxl_options: [],
        zhr_zgdj_options: [],
        // zhr_zgmc_options: [], //资格名称(联动的)

        // // zhr_zgdj_options: "", //专业技术资格等级(联动的)form对象中实现
        // zhr_qdtj_options: [] //资格获取途径 固定
    },
    //---------职业技术资格(联动的)2000
    p9109_job: {
        zhr_zzymc_options:[],
        zhr_jndj_options:[],
        // zhr_zgmc_options: "", //资格名称(联动的)
        // // zhr_zgdj_options: "", //专业技术资格等级(联动的)form对象中实现
        // zhr_qdtj_options: "" //资格获取途径 固定
    },

    //---------省市区联动

    ssq_props: {
        lazy: true,
        lazyLoad(node, resolve) {
            const { level } = node;
            let params = "";
            if (level == 0) {
                //省
                params = {
                    method: "hr-searchhelp",
                    field: "ZPROV"
                };
            } else if (level == 1) {
                //市
                params = {
                    method: "hr-searchhelp",
                    field: "ZCITY",
                    parent1: node.value
                };
            } else if (level == 2) {
                //区/县
                params = {
                    method: "hr-searchhelp",
                    field: "ZDIST",
                    parent1: node.parent.value,
                    parent2: node.value
                };
            } else {
                return;
            }

            request({
                url: "/sap/bc/zhr/zhr",
                method: "get",
                params: params
            }).then(response => {
                if (!response.data.flag) {
                    console.error("[" + params + "]读取失败!" + response.data.message);
                    return;
                }
                // 710000 中国台湾
                // 810000 中国香港
                // 820000 中国澳门
                const nodes = Array.from(response.data.data).map(item => {
                    if (item.id == '710000' || item.id == '810000' || item.id == '820000') {
                        return {
                            value: item.id,
                            label: item.text,
                            leaf: true
                        };
                    } else {
                        return {
                            value: item.id,
                            label: item.text,
                            leaf: level >= 2
                        };
                    }
                });
                resolve(nodes);
            });
        }
    }
}


/**
 * 加载所有固定的下拉值选项
 */
export function loadApplyOptions() {

    //---------内招
    //--------是否有员工号
    options.x_haspernr_options = [{ id: 'Y', text: '是' }, { id: 'N', text: '否' }];

    //1.自定义的
    //---------是否有亲属在五粮液
    options.inwly_options = [{ id: 'Y', text: '是' }, { id: 'N', text: '否' }];
    //---------是否复转军人
    options.retire_soldier_options = [{ id: 'Y', text: '是' }, { id: 'N', text: '否' }];
    //---------是否服从岗位调剂
    options.x_zfctj_options = [{ id: 'Y', text: '是' }, { id: 'N', text: '否' }];
    //---------是否参加入职前实习
    options.x_cjrzqsx_options = [{ id: 'Y', text: '是' }, { id: 'N', text: '否' }];


    //2.从sap加载的固定的
    //---------基本信息：性别，政治面貌，民族，户口性质，健康状况，婚姻状况，关系
  let fieldArr = ["gesch", "pcode", "zzmzu", "zzhkl", "zjkzk", "famst", "zhr_dptyp", "njpm"];
    //---------紧急联系人：与本人关系
    fieldArr.push("zhr_jjybrgx");
    //---------社会关系：与本人关系
    fieldArr.push("subty");
    //---------信息来源：信息来源
    fieldArr.push("zxxly");
    //---------意向面试地
    fieldArr.push("zmsd");

    //---------教育经历：学历、学位、学习形式
    fieldArr.push("zhr_xl", "zhr_xwdj", "zhr_xxxs");
    // 工作经历
    fieldArr.push('zhr_gzxz')
    //---------语言能力：外语语种、熟练程度
    fieldArr.push("zhr_wyyz", "zhr_slcd");

    //3.从sap读取searchHelp
    fieldArr.forEach((field) => {
        request({
            url: "/sap/bc/zhr/zhr",
            params: {
                method: "hr-searchhelp",
                field: field
            }
        }).then(response => {
            if (!response.data.flag) {
                console.error("下拉选项[" + field + "]读取失败!" + response.data.message);
                return;
            }
            let res_options = response.data.data;

            //---------基本信息：性别，政治面貌，民族，户口性质，健康状况，婚姻状况，关系(是否有亲属在五粮液)
            if (field == "gesch") {
                options.gesch_options = res_options;
            } else if (field == "pcode") {
                options.pcode_options = res_options;
            } else if (field == "zzmzu") {
                options.zzmzu_options = res_options;
            } else if (field == "zzhkl") {
                options.zzhkl_options = res_options;
            } else if (field == "zjkzk") {
                options.zjkzk_options = res_options;
            } else if (field == "njpm") {
                options.znjpm_options = res_options;
            } else if (field == "famst") {
                options.famst_options = res_options;
            } else if (field == "zhr_dptyp") {
                options.zhr_dptyp_options = res_options;
            }

            //---------紧急联系人：与本人关系
            else if (field == "zhr_jjybrgx") {
                options.zhr_jjybrgx_options = res_options;
            }
            //---------社会关系：与本人关系
            else if (field == "subty") {
              options.SUBTYP_options = res_options;
            }

            //---------信息来源：信息来源
            else if (field == "zxxly") {
                options.zxxly_options = res_options;
            }

            //---------意向面试地
            else if (field == "zmsd") {
                options.zmsd_options = res_options;
            }


            //---------教育经历：学历、学位、学习形式
            else if (field == "zhr_xl") {
                options.p9100.zhr_xl_options = res_options;
            } else if (field == "zhr_xwdj") {
                options.p9100.zhr_xwdj_options = res_options;
            } else if (field == "zhr_xxxs") {
                options.p9100.zhr_xxxs_options = res_options;
            }
            // 工作经历
            else if (field =='zhr_gzxz'){
              options.p9101.zhr_gzxz_options = res_options
            }

            //---------语言能力：外语语种、熟练程度
            if (field == "zhr_wyyz") {
                options.p9103.zhr_wyyz_options = res_options;
            } else if (field == "zhr_slcd") {
                options.p9103.zhr_slcd_options = res_options;
            }

        }).catch((error) => {
            console.error("下拉选项[" + field + "]读取失败!" + error)
        })

    });


    //4.联动的。 专业、职业技术职格
    //--------------专业技术资格1000：资格名称  资格获取途径
    let cascadArr = [
      // "zhr_zgmc", "zhr_qdtj",
      'zhr_zcxl', 'zhr_zgdj'];
    cascadArr.forEach((field) => {
        request({
            url: "/sap/bc/zhr/zhr",
            params: {
                method: "hr-searchhelp",
                field: field,
                parent1: "1000",
            }
        }).then(response => {
            if (!response.data.flag) {
                console.error("下拉选项[" + field + "]读取失败!" + response.data.message);
                return;
            }
            let res_options = response.data.data;
            if (field == "zhr_zcxl") {
              options.p9109_zy.zhr_zcxl_options = res_options;
            } else if (field == "zhr_zgdj") {
              options.p9109_zy.zhr_zgdj_options = res_options;
            }

            // //---------专业技术资格1000：资格名称  资格获取途径
            // if (field == "zhr_zgmc") {
            //     options.p9109_zy.zhr_zgmc_options = res_options;
            // }
            // else if (field == "zhr_qdtj") {
            //     options.p9109_zy.zhr_qdtj_options = res_options;
            // }
        });
    });

    let cascadArr2 = [
    // "zhr_zgmc", "zhr_qdtj",
    'zhr_zzymc','zhr_jndj'
    ];
    //---------职业技术资格2000：资格名称  资格获取途径
    cascadArr2.forEach((field) => {
        request({
            url: "/sap/bc/zhr/zhr",
            params: {
                method: "hr-searchhelp",
                field: field,
                parent1: "2000",
            }
        }).then(response => {
            if (!response.data.flag) {
                console.error("下拉选项[" + field + "]读取失败!" + response.data.message);
                return;
            }
            let res_options = response.data.data;

          if (field == "zhr_zzymc") {
            options.p9109_job.zhr_zzymc_options = res_options;
          } else if (field == "zhr_jndj") {
            options.p9109_job.zhr_jndj_options = res_options;
          }
            // //---------职业技术资格2000：资格名称  资格获取途径
            // if (field == "zhr_zgmc") {
            //     options.p9109_job.zhr_zgmc_options = res_options;
            // }
            // else if (field == "zhr_qdtj") {
            //     options.p9109_job.zhr_qdtj_options = res_options;
            // }
        });
    });
}

/**
 * 加载外语级别下拉 (联动型)
 * @param {外语语种} wyyz
 */
export function loadZhr_wyjb(wyyz) {
    return new Promise((resolve) => {
        request({
            url: "/sap/bc/zhr/zhr",
            params: {
                method: "hr-searchhelp",
                field: "zhr_wyjb",
                parent1: wyyz
            }
        }).then(res => {
            if (res.data.flag) {
                resolve(res.data);
            } else {
                console.error("下拉选项[" + field + "]读取失败!" + res.data.message);
                resolve([]);
            }
        }).catch((e) => { console.error("下拉选项[" + field + "]读取失败!" + e) })
    });
}



/**
 * 加载专业技术资格等级 (联动型)
 * @param {资格类型} zglx 1000专业/2000职业
 *  @param {资格名称} zgmc
 */
export function loadZhr_zgdj(zglx, zgmc) {
    return new Promise((resolve) => {
        request({
            url: "/sap/bc/zhr/zhr",
            params: {
                method: "hr-searchhelp",
                field: "zhr_zgmc",
                parent1: zglx,
                parent2: zgmc
            }
        }).then(res => {
            if (res.data.flag) {
                resolve(res.data);
            } else {
                console.error("下拉选项[" + field + "]读取失败!" + res.data.message);
                resolve([]);
            }
        }).catch((e) => { console.error("下拉选项[" + field + "]读取失败!" + e) })
    });
}



// WEBPACK FOOTER //
// ./src/utils/options.js